<template>
  <div class="p-2 mt-2">
    <div v-if="!isLoading">
      <FormulateInput
        type="text"
        label="Text Content"
        class="block w-full px-4 ml-4 mb-3 mt-2 leading-tight"
        v-model="contentModel"
        :disabled="configuringStatus"
      />
      <div
        v-if="contentModel && contentModel.length"
        class="text-xs mb-1 text-gray-600"
      ></div>
      <div v-if="!configuringStatus" class="flex justify-between">
        <button
          class="btn btn-secondary border-2 mr-2"
          @click.prevent="addWildCard"
        >
          Add Wildcards
        </button>

        <button
          class="btn btn-secondary border-2"
          @click.prevent="configureWildCards"
        >
          Configure Wildcards
        </button>
      </div>
      <div v-else>
        <button
          class="btn btn-secondary border-2"
          @click.prevent="configureWildCards"
        >
          Edit Text Content
        </button>
      </div>

      <div v-if="configuringStatus">
        <div class="overflow-y-auto flex flex-col border-b">
          <p class="text-sm py-4 px-3">Document Variables</p>
        </div>
        <div v-for="(fields, index) in contentVariables" :key="index">
          <FormulateInput
            type="select"
            v-model="fields.type"
            :options="[
              { value: '{{driverName}}', label: 'Driver Name' },
              { value: '{{inductionDate}}', label: 'Induction Date' },
              {
                value: '{{accreditationNumber}}',
                label: 'Accreditation Number',
              },
              // { value: '{{todayDate}}', label: 'Today(Date)' },
              { value: '{{adminNumber}}', label: 'Admin Number' },
            ]"
            @change="updatePreview(fields.partId)"
          />
        </div>
      </div>
    </div>
    <div v-else>
      <svg
        role="status"
        class="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
        viewBox="0 0 100 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
          fill="currentColor"
        />
        <path
          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
          fill="currentFill"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { HELPER } from "@/api/helper";
export default {
  name: "document-part-controller",

  props: {
    editContent: {
      type: Object,
    },

    selectedType: {
      type: String,
    },

    selectedUUID: {
      type: String,
    },
  },

  data() {
    return {
      currentContainerVariables: [],
      currentContent: "",
      currentSelectedPart: false,
      currentSelectedIndex: -1,

      isLoading: false,
    };
  },

  mounted() {
    if (this.selectedUUID) {
      this.fetchCurrentPart(this.selectedUUID);
    }
  },

  computed: {
    docParts: {
      get() {
        return this.$store.state.accreditation.docParts;
      },
      set(newVal) {
        this.$store.state.accreditation.docParts = newVal;
      },
    },

    contentModel: {
      get() {
        return this.currentSelectedPart.contentPreview;
      },
      set(newVal) {
        this.currentSelectedPart.contentPreview = newVal;
      },
    },

    contentModelLength: {
      get() {
        return this.currentSelectedPart.contentPreview.length;
      },
      set(newVal) {
        this.currentSelectedPart.contentPreview = newVal;
      },
    },

    configuringStatus: {
      get() {
        const model = _.find(
          this.$store.state.accreditation.docParts,
          (data) => {
            return data.uuid === this.selectedUUID;
          }
        );

        return model?.isConfiguring;
      },
    },

    contentVariables: {
      get() {
        const model = _.find(
          this.$store.state.accreditation.docParts,
          (data) => {
            return data.uuid === this.selectedUUID;
          }
        );

        return model.contentVariables;
      },
    },
  },

  watch: {
    selectedUUID: function (data) {
      this.fetchCurrentPart(data);
    },
  },

  methods: {
    configureWildCards() {
      const isConfiguring =
        this.docParts[this.currentSelectedIndex]?.isConfiguring;

      const previews = this.docParts[this.currentSelectedIndex]?.contentPreview;

      if (!isConfiguring) {
        this.generateVariables(previews);
        this.docParts[this.currentSelectedIndex].isConfiguring = !isConfiguring;
      } else {
        this.docParts[this.currentSelectedIndex].content = [];
        this.docParts[this.currentSelectedIndex].contentVariables = [];

        this.docParts[this.currentSelectedIndex].isConfiguring = !isConfiguring;
      }
    },

    addWildCard() {
      const textContent =
        this.docParts[this.currentSelectedIndex].contentPreview;

      this.docParts[this.currentSelectedIndex].contentPreview =
        textContent + " {{variable}} ";
    },

    fetchCurrentPart(partUUID) {
      this.isLoading = true;
      const currentPart = _.find(this.docParts, (part) => {
        return part.uuid == partUUID;
      });

      if (currentPart) {
        const currentIndex = _.findIndex(this.docParts, (part) => {
          return part.uuid == partUUID;
        });

        this.currentSelectedPart = currentPart;
        this.currentSelectedIndex = currentIndex;
      } else {
        this.currentSelectedPart = false;
        this.currentSelectedIndex = -1;
      }
      this.isLoading = false;
    },

    generateVariables(data) {
      const arrContent = data.split(" ");

      let i;

      const paragraphVariables = [];

      for (i = 0; i < arrContent.length; i++) {
        const partId = "part-" + "section-" + HELPER.getUUIDv4();
        if (arrContent[i].match(/{{\s*[\w.]+\s*}}/g)) {
          const match = arrContent[i].match(/{{\s*[\w.]+\s*}}/g);
          paragraphVariables.push({ type: match[0], index: i, partId });
        }
      }

      this.docParts[this.currentSelectedIndex].content = arrContent;
      this.docParts[this.currentSelectedIndex].contentVariables =
        paragraphVariables;
    },

    updatePreview(data) {
      const previewIndex = _.find(this.contentVariables, (contentData) => {
        const model = contentData.partId === data;

        return model;
      });

      this.docParts[this.currentSelectedIndex].content[
        previewIndex.index
      ] = `${previewIndex.type}`;

      const contentArr = this.docParts[this.currentSelectedIndex].content;

      this.docParts[this.currentSelectedIndex].contentPreview =
        contentArr.join(" ");
    },
  },
};
</script>
